import { useScrollToTop } from '@/hooks';
import styles from './BackToTop.module.css';

export function BackToTop() {
  const { visible, scrollToTop } = useScrollToTop();

  if (!visible) return null;

  return (
    <button
      type="button"
      className={styles.btn}
      onClick={scrollToTop}
      aria-label="Back to top of page"
      title="Back to top"
    >
      <span aria-hidden="true">&#8679;</span>
    </button>
  );
}
